import React from 'react';
import EntityModification from 'src/models/entityModificationLogs/EntityModification';
import EntityModificationContract from 'src/models/entityModificationLogs/EntityModificationContract';
import EntityChangeLog from './EntityChangeLog';

interface IBrineLeaseChangeLog {
    changeLogs: EntityModificationContract;
}

const BrineLeaseChangeLog = (props: IBrineLeaseChangeLog) => {
    return (
        <div style={{ width: '40vw' }}>
            {props.changeLogs.contractModifications?.length > 0 && (
                <section style={{ margin: '2rem auto' }}>
                    <EntityChangeLog
                        changeLogs={props.changeLogs.contractModifications}
                        omitKeys={['Id']}
                        legendTitle="Brine Lease Body"
                        keyPrefix="Brine"
                    />
                </section>
            )}
            {props.changeLogs.contractLeaseholdModifications?.length > 0 && (
                <section style={{ margin: '2rem auto' }}>
                    {props.changeLogs.contractLeaseholdModifications.map((lhMods: Array<EntityModification>, index: number) => {
                        // NOTE: Key required for ts lint reasons. Keyprefix has a different function.
                        return (
                            <EntityChangeLog
                                changeLogs={lhMods}
                                omitKeys={['Id']}
                                legendTitle={`Brine Leasehold ${index + 1}`}
                                keyPrefix={`Brine Leasehold ${index}`}
                                key={`Brine Leasehold ${index}`}
                            />
                        );
                    })}
                </section>
            )}
            {props.changeLogs.contractLeaseTractModifications?.length > 0 && (
                <section style={{ margin: '2rem auto' }}>
                    {props.changeLogs.contractLeaseTractModifications.map((ltMods: Array<EntityModification>, index: number) => {
                        // NOTE: Key required for ts lint reasons. Keyprefix has a different function.
                        return (
                            // <div key={'Testing: ' + index}>Does this work?</div>
                            <EntityChangeLog
                                changeLogs={ltMods}
                                omitKeys={['Id', 'HorizonId', 'ContractLookupId', 'InvoiceableLookupId']}
                                legendTitle={`Contract Generation Tract Detail ${index + 1}`}
                                keyPrefix={`Contract Generation Tract Detail ${index}`}
                                key={`Contract Generation Tract Detail ${index}`}
                            />
                        );
                    })}
                </section>
            )}
            {props.changeLogs.adHocClauseModifications?.length > 0 && (
                <section style={{ margin: '2rem auto' }}>
                    {props.changeLogs.adHocClauseModifications.map((ahcMods: Array<EntityModification>, index: number) => {
                        // NOTE: Key required for ts lint reasons. Keyprefix has a different function.
                        return (
                            <EntityChangeLog
                                changeLogs={ahcMods}
                                omitKeys={['Id', 'ContractLookupId', 'InvoiceableLookupId', 'LeaseId', 'LeaseClauseType']}
                                legendTitle={`Ad Hoc Clauses ${index + 1}`}
                                keyPrefix={`Ad Hoc Clauses ${index}`}
                                key={`Ad Hoc Clauses ${index}`}
                            />
                        );
                    })}
                </section>
            )}
            {props.changeLogs.acknowledgmentModifications?.length > 0 && (
                <section style={{ margin: '2rem auto' }}>
                    {props.changeLogs.acknowledgmentModifications.map((ackMods: Array<EntityModification>, index: number) => {
                        // NOTE: Key required for ts lint reasons. Keyprefix has a different function.
                        return (
                            <EntityChangeLog
                                changeLogs={ackMods}
                                omitKeys={['Id']}
                                legendTitle={`Acknowledgments ${index + 1}`}
                                keyPrefix={`Acknowledgments ${index}`}
                                key={`Acknowledgments ${index}`}
                            />
                        );
                    })}
                </section>
            )}
            {/* {props.changeLogs.contractClauseModifications?.length > 0 && (
                <section style={{ margin: '2rem auto' }}>
                    <EntityChangeLog
                        changeLogs={props.changeLogs.contractClauseModifications}
                        omitKeys={['Id']}
                        legendTitle="Contract Clause List"
                        keyPrefix="Contract Clause"
                    />
                </section>
            )} */}
        </div>
    );
};

export default BrineLeaseChangeLog;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/EntityModificationComponents/BrineLeaseChangeLog.tsx